import { json } from '@remix-run/node'
import { useLoaderData } from '@remix-run/react'
import { P } from '#app/components/typography/p.tsx'
import { Span } from '#app/components/typography/span.tsx'
import { Code } from '#app/old_components/typography/code.tsx'
import { readSource } from '../sections/sections.server.tsx'
import { Description, Features, Source, type componentProps, Parts, Usage, Styling } from '../sections/sections.tsx'

export const handle = {
	breadcrumb: 'Span',
}

const component: componentProps = {
	name: 'Span',
	shortName: 'Span',
	fileName: 'span',
	category: 'typography',
	description: ['A span element with control for typographic attributes.'],
	features: [
		'Drop-in replacement for the native <span> element.',
		"Automatically inherits the parent's design tokens (just like a normal span tag).",
		'Allows control of size, weight, alignment, and tracking.',
	],
	parts: [],
	usage: `<P>
	<Span>This is a span.</Span>
</P>`,
	styling: ``,
}

export const loader = async () => json({ source: await readSource({ category: component.category, fileName: component.fileName }) })

const SpanRoute = () => {
	const { source } = useLoaderData<typeof loader>()
	const { name, description, shortName, fileName, features, usage, parts, styling } = component

	return (
		<>
			<Description name={name} description={description} />
			<P className="mt-4">
				Generally, <Code>span</Code> tags will go inside <Code>p</Code> tags and inherit whatever typographical attributes that paragraph has. But because spans are not limited to being
				inside paragraphs, this elements also allows you to control typographic attributes.
			</P>
			<Features features={features} />
			<Parts parts={parts} />
			<P className="mt-4">The tracking's default value depends on the size prop and is controlled through CSS variables: check out the styling section.</P>
			<Usage usage={usage} shortName={shortName} />
			<P>
				<Span>This is a span.</Span>
			</P>
			<Source source={source} fileName={fileName} />
			<Styling styling={styling} />
		</>
	)
}
export default SpanRoute
